import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare, PenTool, Upload, Target, Send, Video, Languages, Download, Plane, Gift } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import './DashboardPage.css';

const features = [
  {
    icon: Upload,
    title: 'Profilini Oluştur',
    desc: 'CV yükle, yapay zeka profilini otomatik oluştursun.',
    link: '/panel/profil',
    color: '#2F3A8F',
  },
  {
    icon: Send,
    title: 'Başvurularım',
    desc: 'İş başvurularını takip et ve durumlarını gör.',
    link: '/panel/basvurularim',
    color: '#00C9A7',
  },
  {
    icon: PenTool,
    title: 'CV Oluştur',
    desc: 'Profesyonel CV\'ni yapay zeka ile oluştur ve indir.',
    link: '/panel/cv-olustur',
    color: '#10B981',
  },
  {
    icon: Video,
    title: 'Toplantı Notlarım',
    desc: 'Toplantı kayıtlarını, özetlerini ve çevirilerini gör.',
    link: '/panel/toplantilarim',
    color: '#8B5CF6',
  },
  {
    icon: MessageSquare,
    title: 'Deneme Mülakatı',
    desc: 'Yapay zeka ile mülakat simülasyonu yap.',
    link: '/panel/mulakat',
    color: '#EC4899',
  },
  {
    icon: Target,
    title: 'İlan Uyum Analizi',
    desc: 'İlan linkini yapıştır, kayıtlı CV\'nle uyumunu ve eksiklerini gör.',
    link: '/panel/uyum-analizi',
    color: '#059669',
  },
  {
    icon: Plane,
    title: 'Yurt Dışı Planım',
    desc: 'Oturum, çalışma izni ve yerleşim planını soru-cevapla netleştir.',
    link: '/panel/yurtdisi',
    color: '#FF6B35',
  },
];

const DashboardPage = () => {
  const { user } = useAuth();
  const [jobSearchActive, setJobSearchActive] = useState(true);

  return (
    <div className="dashboard-page">
      <div className="dashboard__container">
        <div className="dashboard__welcome">
          <div className="dashboard__welcome-text">
            <h1 className="dashboard__title">
              Merhaba{user?.name ? `, ${user.name}` : ''}
            </h1>
            <p className="dashboard__subtitle">Kariyer yolculuğunu yapay zeka ile güçlendir.</p>
          </div>
        </div>

        {/* Job Search Toggle */}
        <div className="dashboard__status-card">
          <div className="dashboard__status-info">
            <div className={`dashboard__status-dot ${jobSearchActive ? 'dashboard__status-dot--active' : 'dashboard__status-dot--passive'}`} />
            <div>
              <span className="dashboard__status-label">İş Arayışı</span>
              <span className={`dashboard__status-text ${jobSearchActive ? 'dashboard__status-text--active' : 'dashboard__status-text--passive'}`}>
                {jobSearchActive ? 'Aktif' : 'Pasif'}
              </span>
            </div>
          </div>
          <p className="dashboard__status-desc">
            {jobSearchActive
              ? 'İş aramanız aktif. Yapay Zeka uygun ilanları sizinle eşleştirecek.'
              : 'İş aramanız pasif. İlanlarla eşleştirme ve bildirimler duraklatıldı.'}
          </p>
          <button
            className={`dashboard__toggle ${jobSearchActive ? 'dashboard__toggle--active' : ''}`}
            onClick={() => setJobSearchActive(!jobSearchActive)}
            aria-label="İş arayışı durumu"
          >
            <span className="dashboard__toggle-thumb" />
          </button>
        </div>

        {/* TransMeet, masaüstü toplantı çevirmeni */}
        <a
          href="/indir"
          target="_blank"
          rel="noopener noreferrer"
          className="dashboard__transmeet"
        >
          <div className="dashboard__transmeet-icon">
            <Languages size={22} />
          </div>
          <div className="dashboard__transmeet-text">
            <div className="dashboard__transmeet-title-row">
              <h3 className="dashboard__transmeet-title">TransMeet: Toplantı Çevirmeni</h3>
              <span className="dashboard__transmeet-badge"><Gift size={14} /> İlk 60 dakika ücretsiz</span>
            </div>
            <p className="dashboard__transmeet-desc">
              Toplantılarınızı anlık çevirin, kaydedin ve özetleyin.
              <br />
              <strong>Uygulamaya isBulsun.com üyeliğiniz ile giriş yapabilirsiniz.</strong>
            </p>
          </div>
          <span className="dashboard__transmeet-btn">
            <Download size={16} />
            Uygulamayı İndir
          </span>
        </a>

        <div className="dashboard__grid">
          {features.map((f, i) => (
            <Link to={f.link} key={i} className="dashboard__card">
              <div className="dashboard__card-icon" style={{ background: `${f.color}12`, color: f.color }}>
                <f.icon size={22} />
              </div>
              <h3 className="dashboard__card-title">{f.title}</h3>
              <p className="dashboard__card-desc">{f.desc}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
